import { render, staticRenderFns } from "./ClaimOrDispute.vue?vue&type=template&id=0d16cc72&scoped=true"
import script from "./ClaimOrDispute.vue?vue&type=script&lang=js"
export * from "./ClaimOrDispute.vue?vue&type=script&lang=js"
import style0 from "./ClaimOrDispute.vue?vue&type=style&index=0&id=0d16cc72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16cc72",
  null
  
)

export default component.exports